import { Decision } from '../../decision/decision.types';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { WatcherSearchQueryParamsCategories } from '../../watchers/watchers.types';

type StringOrArray = Array<string> | string;

type MixedArray = Array<StringOrArray>;

const getFilterLastPartAfterArrow = (filter: string): string => {
  const parts = filter.split(' -> ');
  return parts[parts.length - 1];
};

const cleanFilter = (filter: Array<string>): Array<string> =>
  filter.map((item: string) => getFilterLastPartAfterArrow(item));

const cleanFiltersAndFlatten = (filters: MixedArray): Array<string> =>
  filters.map((current: StringOrArray) => {
    const currentFilterInFlatArray = ([] as Array<string>).concat(current);
    return cleanFilter(currentFilterInFlatArray).join(' ');
  });

const isParentIncluded = (parent: string, subsection: string) => {
  const parentWords = parent.split(' ');
  const subSectionWords = subsection.split(' ');
  return parentWords.every(
    (word, index) => index === subSectionWords.indexOf(word),
  );
};

const removeParentFiltersOnSortedList = (
  formattedFilters: Array<string>,
): Array<string> => {
  let displayedFilters: Array<string> = [];

  formattedFilters.forEach((current, index, array) => {
    const previous = index > 0 ? array[index - 1] : array[0];

    if (isParentIncluded(previous, current)) {
      displayedFilters = displayedFilters.filter(
        currentFilter => currentFilter !== previous,
      );
    }
    displayedFilters.push(current);
  });

  return displayedFilters;
};

export const formatWatcherFiltersTags = (
  filtersTypes: WatcherSearchQueryParamsCategories,
) => {
  const filtersTypesValues: Array<MixedArray | undefined> = filtersTypes
    ? Object.values(filtersTypes)
    : [];

  const formattedFilters: Array<string> = filtersTypesValues
    ? filtersTypesValues
        .reduce(
          (accumulator: Array<string>, current: MixedArray | undefined) => {
            if (current) {
              return accumulator.concat(cleanFiltersAndFlatten(current));
            }
            return accumulator;
          },
          [],
        )
        .sort()
    : [];

  return removeParentFiltersOnSortedList(formattedFilters);
};

export function getKeywords(
  decision: Pick<Decision, 'htmlKeywords' | 'rawKeywords'>,
) {
  return decision.htmlKeywords.map((keyword: string, i: number) => ({
    html: keyword,
    label: decision.rawKeywords[i],
    id: i,
  }));
}

export function sendResultClickedEvent(
  comment: { position: number; commentaireId: number; url: string },
  originalQueryKey: string,
) {
  doctrineAnalytics('Search ResultClicked', {
    type: 'comment',
    position: comment.position,
    commentaire_id: comment.commentaireId,
    url: comment.url,
    original_query_key: originalQueryKey,
  });
}

export function trackAddDecisionWatcher(source: string) {
  doctrineAnalytics('Search SearchWatchClicked', { source });
}
